import React from 'react';
import {BrowserRouter as Router,Route} from 'react-router-dom';


import { Main } from './components/main'

import { Welcome } from './components/welcome'

import './styles/header.css'



class App extends React.Component {

    componentDidMount() {
    }

  render() {
    return (
    <div id="b">
        <ul id="h" className="menu-list">
            <li className="selected"><a href="/">Homepage</a></li>
            <li className="selected"><a href="/record">RECORD</a></li>
            <li className="selected"><a href="https://aws-fraud-tools.amazon.com" target="_blank">Submit Exposed Keys</a></li>
        </ul>
      <Router>
        <div>
          <Route exact path="/" component={Welcome}/>
          <Route exact path="/record" component={Main}/>
        </div>
      </Router>
    </div>
    );
  }
}

export default App;


// WEBPACK FOOTER //
// ./src/App.js